<template>
  <span class="help-tooltip-wrapper">
    <slot>
      <i class="ri-question-line help-icon"></i>
    </slot>
    <span class="help-tooltip">{{ content }}</span>
  </span>
</template>

<script>
export default {
  name: 'HelpTooltip',
  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.help-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.help-icon {
  color: #6c757d;
  cursor: help;
  font-size: 14px;
  margin-left: 4px;
}

.help-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  transition: opacity 0.2s;
  pointer-events: none;
}

.help-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.help-tooltip-wrapper:hover .help-tooltip {
  visibility: visible;
  opacity: 1;
}
</style> 